import { render } from "./SeedJung_Counselor_YSC.vue?vue&type=template&id=1a4db2bc&scoped=true"
import script from "./SeedJung_Counselor_YSC.vue?vue&type=script&lang=js"
export * from "./SeedJung_Counselor_YSC.vue?vue&type=script&lang=js"

import "./SeedJung_Counselor_YSC.vue?vue&type=style&index=0&id=1a4db2bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4db2bc"]])

export default __exports__